import {Injectable} from '@angular/core';
import {AngularFireDatabase} from "@angular/fire/database";
import {Observable} from "rxjs";
import {Reservation} from "./reservation";
import {CommandService} from "./command.service";
import 'rxjs/add/operator/map';
import { of } from "rxjs";
import {User} from "./user";

@Injectable()
// @ts-ignore
export class ReservationsService {

  static reservationsPath: string = "/reservations/";
  reservationsArr: Reservation[];

  constructor(private db: AngularFireDatabase, private commandService: CommandService ) {
  }

  delete(dbPath: string) {
    const itemRef = this.db.object(ReservationsService.reservationsPath + dbPath);
    //console.log("Deleting " + FieldsService.fieldsPath + dbPath);
    itemRef.remove();
  }

  findAllUsers():Observable<User[]> {
    return this.db.list('users').valueChanges().map(User.fromJsonArray);
  }

  findReservationsForClub(id: string): Observable<Reservation[]> {
    //console.log(`findReservationsForClub: ${id}`);
    return this.db.list<Reservation>(ReservationsService.reservationsPath + id, ref => ref.orderByChild('start') ).valueChanges().map(Reservation.fromJsonArray)
  }

  addReservation( payload: any ) {
    const id = Math.floor((Math.random() * 100000) + 1);
    payload['transactionId'] = "RES" + id.toString();
    payload['reservationId'] = 'ST' + id.toString();
    payload['request'] = 'DB_ADD_RESERVATION';
    this.commandService.sendCommand(payload);
  }
}
